import * as React from 'react';
import { Icon } from 'ui';
import { prefixClassName } from 'framework/components/ui/_conf';
import { useMobileNav } from './MobileNavContext';

const navigationClass = prefixClassName('navigation');

const MobileBurgerMenu = () => {
  const { isMobile, isMobileNavOpen, toggleMobileNav } = useMobileNav();

  if (!isMobile || isMobileNavOpen) return null;

  return (
    <button
      type="button"
      className={`${navigationClass}__burger`}
      onClick={toggleMobileNav}
      aria-label="Toggle navigation"
    >
      <Icon name="menu" />
    </button>
  );
};

export default MobileBurgerMenu;
